import { LockerAPI } from "@brg/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchLockStatus = createAsyncThunk(
    'lock/fetchLockStatus',
    async (args: any) => {
        const { accountId, objectId } = args;

        const json = (
            LockerAPI.CanEdit({ accountId, objectId })
            .then((r) => r.json())
        )
      return json;
    }
  );

  export const fetchLockData = createAsyncThunk(
    'lock/fetchLockData',
    async (args: any) => {
        const { objectId } = args;

        const json = (
            LockerAPI.GetLock({ objectId })
            .then((r) => r.json())
        )

      return json;
    }
  );

  export const setLock = createAsyncThunk(
    'lock/setLock',
    async (args: any) => {
        const { objectId } = args;

        const json = (
            LockerAPI.SetLock({ objectId })
            .then((r) => r.json())
        )

      return json;
    }
  );

  export const refreshLock = createAsyncThunk(
    'lock/refreshLock',
    async (args: any) => {
        const { objectId } = args;

        const json = (
            LockerAPI.RefreshLock({ objectId })
            .then((r) => r.json())
        )

      return json;
    }
  );

  export const clearLock = createAsyncThunk(
    'lock/clearLock',
    async (args: any) => {
        const { accountId, objectId } = args;

        const json = (
            LockerAPI.ClearLock({ accountId, objectId })
            .then((r) => r.json())
        )

      return json;
    }
  );import { LockerAPI } from "@brg/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchLockStatus = createAsyncThunk(
    'lock/fetchLockStatus',
    async (args: any) => {
        const { accountId, objectId } = args;

        const json = (
            LockerAPI.CanEdit({ accountId, objectId })
            .then((r) => r.json())
        )
      return json;
    }
  );

  export const fetchLockData = createAsyncThunk(
    'lock/fetchLockData',
    async (args: any) => {
        const { objectId } = args;

        const json = (
            LockerAPI.GetLock({ objectId })
            .then((r) => r.json())
        )

      return json;
    }
  );

  export const setLock = createAsyncThunk(
    'lock/setLock',
    async (args: any) => {
        const { objectId } = args;

        const json = (
            LockerAPI.SetLock({ objectId })
            .then((r) => r.json())
        )

      return json;
    }
  );

  export const refreshLock = createAsyncThunk(
    'lock/refreshLock',
    async (args: any) => {
        const { objectId } = args;

        const json = (
            LockerAPI.RefreshLock({ objectId })
            .then((r) => r.json())
        )

      return json;
    }
  );

  export const clearLock = createAsyncThunk(
    'lock/clearLock',
    async (args: any) => {
        const { accountId, objectId } = args;

        const json = (
            LockerAPI.ClearLock({ accountId, objectId })
            .then((r) => r.json())
        )

      return json;
    }
  );